
var dateService = angular.module('dateService', []);
dateService.factory("DateService", ["$http", "$q", "authServiceFactory", "SchoolModelService", 
    function ($http, $q, authServiceFactory, SchoolModelService) {

    let getCurrentYear = function($item)
    {
        var d = new Date();
        var currentMonth = d.getMonth() + 1;   
        var currentYear = parseInt(d.getFullYear());
        if ($item == undefined)
            var item = SchoolModelService.get()[0];
        else
            var item = $item;

        if (item.Year_End == 12) {
            currentYear = currentYear;
        } else if (item.Year_End > 4 && currentMonth > item.Year_End) {
            currentYear = currentYear+1;
        } else if (item.Year_End > 4 && currentMonth <= item.Year_End) {
            currentYear = currentYear;
        } else if (item.Year_End <= 4 && currentMonth > item.Year_End) {
            currentYear = currentYear;
        } else if (item.Year_End <= 4 && currentMonth <= item.Year_End) {
            currentYear = currentYear-1;
        }

        // Some schools work in a previous year than the current one
        if (item.yearDiff)
            currentYear+=parseInt(item.yearDiff);

        return currentYear;
    };

    return {
        getCurrentYear: getCurrentYear
    };
}]);
